import * as React from 'react'
import { Box, Typography, Button, Toolbar } from 'cs-kevlar-react'
import { InfoOutlined } from 'cs-kevlar-react/lib/es/icons'
import {
  makeStyles,
  createStyles,
  useTheme,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginLeft: theme.spacing(4),
    },
    leftGutter: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.primary.contrastText,
    },
    rightGutter: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
    center: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 0,
      flexGrow: 1,
      marginLeft: theme.spacing(16),
    },
    toolbar: {
      minHeight: 40,
      height: 40,
      backgroundColor: theme.palette.primary.main,
      width: '100vw',
      paddingLeft: theme.spacing(8),
      paddingRight: 0,
    },
    assistAction: {
      height: '100%',
      borderRadius: 0,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderLeft: `1px solid ${theme.palette.primary.dark}`,
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      },
      '&:focus': {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.contrastText,
      },
      '&:active': {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
      },
    },
  }),
)

interface AssistBannerProps {
  onQuitAssistMode: () => void
  onReturnToAssistMode: () => void
  showReturnToAssistButton: boolean
  assistedAgencyName?: string
}

export const AssistBanner: React.FunctionComponent<AssistBannerProps> = ({
  onQuitAssistMode,
  onReturnToAssistMode,
  showReturnToAssistButton,
  assistedAgencyName,
}) => {
  const classes = useStyles({})

  return (
    <Toolbar className={classes.toolbar} disableGutters>
      <Box className={classes.leftGutter}>
        <InfoOutlined />
        <Typography variant="body1" noWrap className={classes.title}>
          Assist Mode
        </Typography>
      </Box>
      <Box className={classes.center}></Box>
      <Box className={classes.rightGutter}>
        {showReturnToAssistButton && (
          <Button
            variant="text"
            className={classes.assistAction}
            onClick={onReturnToAssistMode}
          >
            Back to {assistedAgencyName}
          </Button>
        )}
        <Button
          variant="text"
          className={classes.assistAction}
          onClick={onQuitAssistMode}
        >
          Quit Assist Mode
        </Button>
      </Box>
    </Toolbar>
  )
}
